import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import {
  CountryNames,
  LoginResponse,
  GenericResponse,
  CifDetails,
  CorporateUserDetails,
  GetCompanyAccounts,
  UserProfile,
  LeadResponse,
  ProspectiveLeadsResponse,
  PortalUsers,
  RetailCustomer,
  RetailCustomerList,
  RetailClientClassificationList,
  ServiceTypes,
  ServiceRequests,
  ReportTypes,
  HoldQueueResponse,
  UserProfileReport,
  UserPermissionReport,
  DecisionTypes,
  DecisionRules,
  DecisionTable,
  DecisionParameters,
  UpdateDecisionParameter,
  UpdateDecisionTimes,
  ScanBeneficiary,
  SwiftTransfers,
  CreateInvitation,
  IncomeSourcesValue,
  InvitationData,
  CustomerFormData,
  ClientClassificationFormData,
  CustomerIdentityDetails,

} from 'src/app/interfaces/apiresponses';
import { environment } from 'src/environments/environment';
import { apidefinitions } from './apidefinitions';

@Injectable({
  providedIn: 'root'
})

export class RestService {

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    })
  };

  getAuthorizedHeader() {
    var httpOptionsWithAuth = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      })
    };

    return httpOptionsWithAuth
  }

  getCountryList() {
    let url = environment.baseUrl + apidefinitions.CountryNames;
    return this.http.post<CountryNames>(url, null, this.httpOptions);
  }

  login(credentials: { email: string; password: string }) {
    var loginRequest = {
      EmailId: credentials.email,
      Password: credentials.password,
    };

    let url = environment.baseUrl + apidefinitions.loginUrl;
    return this.http.post<LoginResponse>(url, loginRequest, this.httpOptions);
  }

  requestOTP(param: { email: string }) {
    var otpRequest = {
      EmailID: param.email
    }

    let url = environment.baseUrl + apidefinitions.OTPRequestUrl;
    return this.http.post<GenericResponse>(url, otpRequest, this.httpOptions)
  }

  validateOTP(param: { email: string, OTP: string }) {
    var validateRequest = {
      EmailID: param.email,
      OTP: param.OTP
    }

    let url = environment.baseUrl + apidefinitions.OTPValidateUrl;
    return this.http.post<GenericResponse>(url, validateRequest, this.httpOptions)
  }

  forgotPasswordRequest(param: { email: string }) {
    var request = {
      EmailID: param.email
    }

    let url = environment.baseUrl + apidefinitions.ResetPassword;
    return this.http.post<GenericResponse>(url, request, this.httpOptions)
  }

  getCifDetails(param: { cif: string }) {
    var request = {
      cifNumber: param.cif
    }

    let url = environment.baseUrl + apidefinitions.GetCifDetails;
    return this.http.post<CifDetails>(url, request, this.getAuthorizedHeader())
  }

  getCorporateCustomers(param: { cif: string }) {
    var request = {
      cif: param.cif
    }

    let url = environment.baseUrl + apidefinitions.GetCorporateUsers;
    return this.http.post<CorporateUserDetails>(url, request, this.getAuthorizedHeader())
  }

  getUserProfile(UserId: number) {
    var request = {
      userId: UserId
    }

    let url = environment.baseUrl + apidefinitions.GetUserProfile;
    return this.http.post<UserProfile>(url, request, this.getAuthorizedHeader())
  }

  getCompanyAccounts(param: { cif: string }) {
    var request = {
      cif: param.cif,
      accountType: 4
    }

    let url = environment.baseUrl + apidefinitions.GetCompanyAccounts;
    return this.http.post<GetCompanyAccounts>(url, request, this.getAuthorizedHeader())
  }

  updateUserProfile(profile: any) {
    var request = {
      userId: profile.userId,
      name: profile.name,
      emailId: profile.emailId,
      mobileNumber: profile.mobileNumber,
      isEID: profile.isEID,
      eidNumber: profile.eidNumber,
      dateOfBirth: profile.dateOfBirth,
      nationalityCountryCode: profile.nationalityCountryCode,
      genderId: profile.genderId,
      expiresOn: profile.expiresOn
    }

    let url = environment.baseUrl + apidefinitions.UpdateUserProfile;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  updateUserMatrix(userId: number, matrices: any) {
    var request = {
      userId: userId,
      approvalMatrices: matrices
    }

    let url = environment.baseUrl + apidefinitions.UpdateUserMatrix;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  createCorporatecustomer(customer: any) {
    var request = {
      name: customer.name,
      emailId: customer.emailId,
      mobileNumber: customer.mobileNumber,
      isEID: customer.isEID,
      eidNumber: customer.eidNumber,
      dateOfBirth: customer.dateOfBirth,
      nationalityCountryCode: customer.nationalityCountryCode,
      genderId: customer.genderId,
      expiresOn: customer.expiresOn,
      companyId: customer.companyId,
      role: customer.role,
      approvalMatrices: customer.approvalMatrices
    }

    let url = environment.baseUrl + apidefinitions.CreateCustomer;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  getRejectedCorporateCustomers(param: { cif: string }) {
    var request = {
      cif: param.cif
    }

    let url = environment.baseUrl + apidefinitions.GetRejectedCustomers;
    return this.http.post<CorporateUserDetails>(url, request, this.getAuthorizedHeader())
  }

  getPendingCorporateCustomers(param: { cif: string }) {
    var request = {
      cif: param.cif
    }

    let url = environment.baseUrl + apidefinitions.GetPendingCustomers;
    return this.http.post<CorporateUserDetails>(url, request, this.getAuthorizedHeader())
  }

  approveOrRejectCustomerProfile(UserId: number, Approve: boolean, RejectReason: string) {
    var request = {
      userId: UserId,
      approve: Approve,
      rejectionReason: RejectReason
    }

    let url = environment.baseUrl + apidefinitions.ApproveOrRejectCustomerProfile;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  approveOrRejectCustomerPermissions(UserId: number, Reference: string, Approve: boolean, RejectReason: string) {
    var request = {
      userId: UserId,
      reference: Reference,
      bApproved: Approve,
      rejectReason: RejectReason
    }

    let url = environment.baseUrl + apidefinitions.ApproveOrRejectCustomerPermissions;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  activateOrDeactivateCustomerRequest(UserId: number, Action: boolean) {
    var request = {
      userId: UserId,
      actionRequest: Action
    }

    let url = environment.baseUrl + apidefinitions.ActivateOrDeactivateRequest;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  approveOrRejectCustomerActivation(UserId: number, Approve: boolean) {
    var request = {
      userId: UserId,
      Approve: Approve
    }

    let url = environment.baseUrl + apidefinitions.ApproveOrRejectCustomerActivationRequest;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  getCompanyLeadsByName(IsGetAll: boolean, CompanyName: string) {
    var request = {
      searchByNamePartialMatch: CompanyName,
      isGetAll: IsGetAll,
      pageSize: 10000,
      startId: 0
    }

    let url = environment.baseUrl + apidefinitions.GetLeads;
    return this.http.post<LeadResponse>(url, request, this.getAuthorizedHeader())
  }

  getCompanyLeadsByTradeLicense(IsGetAll: boolean, TradeLicense: string) {
    var request = {
      searchByTradeLicense: TradeLicense,
      isGetAll: IsGetAll,
      pageSize: 10000,
      startId: 0
    }

    let url = environment.baseUrl + apidefinitions.GetLeads;
    return this.http.post<LeadResponse>(url, request, this.getAuthorizedHeader())
  }

  approveOrRejectLead(Reference: string, Approve: boolean, RejectReason: string, Cif: string) {
    var request = {
      registerRequestor: true,
      reference: Reference,
      approve: Approve,
      rejectReason: RejectReason,
      cif: Cif
    }

    let url = environment.baseUrl + apidefinitions.ApproveOrRejectLead;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  getProspectiveLeads(fromDate: string, toDate: string, status: string) {
    var request = {
      fromDate: fromDate,
      toDate: toDate,
      status: status
    }

    let url = environment.baseUrl + apidefinitions.GetProspectiveLeads;
    return this.http.post<ProspectiveLeadsResponse>(url, request, this.getAuthorizedHeader())
  }

  updateProspectiveLead(id: number, leadStatus: string, comments: string) {
    var request = {
      Id: id,
      LeadStatus: leadStatus,
      Comments: comments
    }

    let url = environment.baseUrl + apidefinitions.UpdateProspectiveLead;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  getAllPortalUsers() {
    let url = environment.baseUrl + apidefinitions.GetAllPortalUsers;
    return this.http.post<PortalUsers>(url, {}, this.getAuthorizedHeader())
  }

  updatePortalUser(Name: string, Email: string, Mobile: string, Role: number) {
    var request = {
      name: Name,
      emailId: Email,
      mobileNumber: Mobile,
      userType: Role
    }

    let url = environment.baseUrl + apidefinitions.UpdatePortalUser;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  resetPortalUserPassword(Email: string) {
    var request = {
      emailId: Email
    }

    let url = environment.baseUrl + apidefinitions.ResetPortalUserPassword;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  deactivatePortalUser(Email: string, Deactivate: boolean) {
    var request = {
      emailID: Email,
      Deactivate: Deactivate
    }

    let url = environment.baseUrl + apidefinitions.DeactivatePortalUser;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  createPortalUser(Name: string, Email: string, Mobile: string, Role: number) {
    var request = {
      name: Name,
      emailId: Email,
      mobileNumber: Mobile,
      userType: Role
    }

    let url = environment.baseUrl + apidefinitions.CreatePortalUser;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  getRetailCustomer(Email: string) {
    var request = {
      emailId: Email
    }

    let url = environment.baseUrl + apidefinitions.GetRetailCustomer;
    return this.http.post<RetailCustomer>(url, request, this.getAuthorizedHeader())
  }

  getCustomerIdentityDetailsByEmail(Email: string) {
    var request = {
      emailId: Email
    }

    let url = environment.baseUrl + apidefinitions.GetCustomerIdentityDetailsByEmail;
    return this.http.post<CustomerIdentityDetails>(url, request, this.getAuthorizedHeader())
  }

  getRetailCustomersList() {
    let url = environment.baseUrl + apidefinitions.GetRetailCustomersList;
    return this.http.get<RetailCustomerList>(url, this.getAuthorizedHeader())
  }
  getClientClasificationslist() {
    let url = environment.baseUrl + apidefinitions.getClientClasificationslist;
    return this.http.get<RetailClientClassificationList>(url, this.getAuthorizedHeader())
  }
  resetRetailCustomerPassword(Email: string) {
    var request = {
      emailId: Email
    }

    let url = environment.baseUrl + apidefinitions.ResetRetailCustomerPassword;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  getServiceTypes() {
    var request = {
      serviceTypeID: 1
    }


    let url = environment.baseUrl + apidefinitions.GetServiceTypes;
    return this.http.post<ServiceTypes>(url, request, this.getAuthorizedHeader())
  }

  getServiceTypesComplaints() {
     var request = {
      serviceTypeID: 2
    }

    let url = environment.baseUrl + apidefinitions.GetServiceTypes;
    return this.http.post<ServiceTypes>(url, request, this.getAuthorizedHeader())
  }

  getServiceRequests(ServiceTicketType: string, FromDate: string, ToDate: string, ShowTicketType: number, serviceTypeID: number) {
    var request = {
      serviceTicketType: ServiceTicketType,
      fromDate: FromDate,
      toDate: ToDate,
      showTicketType: ShowTicketType,
      serviceTypeID: serviceTypeID
    }

    let url = environment.baseUrl + apidefinitions.GetServiceRequests;
    return this.http.post<ServiceRequests>(url, request, this.getAuthorizedHeader())
  }

  resolveServiceRequest(RequestId: string, Response: string, internalRemarks: string, Status: string, sendRemarksToCustomer: boolean = false) {
    var request = {
      requestId: RequestId,
      response: Response,
      internalRemarks: internalRemarks,
      status: Status,
      sendRemarksToCustomer: sendRemarksToCustomer
    }

    let url = environment.baseUrl + apidefinitions.ResolveTicket;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  getReportTypes() {
    let url = environment.baseUrl + apidefinitions.GetMakerCheckerFunctions;
    return this.http.post<ReportTypes>(url, null, this.getAuthorizedHeader())
  }

  getHoldQueueReport(ReportType: string, StartDate: string, EndDate: string) {
    var request = {
      reportType: ReportType,
      startDate: StartDate,
      endDate: EndDate
    }

    let url = environment.baseUrl + apidefinitions.GetHoldQueueReport;
    return this.http.post<HoldQueueResponse>(url, request, this.getAuthorizedHeader())
  }

  getUserManagementReport(StartDate: string, EndDate: string) {
    var request = {
      startDate: StartDate,
      endDate: EndDate
    }

    let url = environment.baseUrl + apidefinitions.GetUserManagementReport;
    return this.http.post<UserProfileReport>(url, request, this.getAuthorizedHeader())
  }

  getUserPermissionReport(CompanyCIF: string | null, StartDate: string | null, EndDate: string | null) {
  const request = {
    cif: CompanyCIF ?? null,
    startDate: StartDate ?? null,
    endDate: EndDate ?? null
  };
  
    let url = environment.baseUrl + apidefinitions.GetUserPermissionReport;
    return this.http.post<UserPermissionReport>(url, request, this.getAuthorizedHeader())
  }

  approveOrDisapprovePortalUser(UserId: number, Approve: boolean, DisapprovalReason: string) {
    var request = {
      userId: UserId,
      approve: Approve,
      disapprovalReason: DisapprovalReason
    }

    let url = environment.baseUrl + apidefinitions.ApproveOrRejectPortalUser;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }

  changePortalUserPassword(Password: string) {
    var request = {
      password: Password
    }

    let url = environment.baseUrl + apidefinitions.ChangePortalUserPassword;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }
  /************Onboarding API function******/

  getDecisionDataTypes() {
    let url = environment.baseUrl + apidefinitions.getDecisionDataTypes;
    return this.http.post<DecisionTypes>(url, null, this.getAuthorizedHeader())
  }
  getDecisionRules() {
    let url = environment.baseUrl + apidefinitions.getDecisionRules;
    return this.http.post<DecisionRules>(url, null, this.getAuthorizedHeader())
  }
  getDecisionParameters() {
    let url = environment.baseUrl + apidefinitions.getDecisionParameters;
    return this.http.post<DecisionParameters>(url, null, this.getAuthorizedHeader())
  }
  updateDecisionParameter(request: any) {
    let url = environment.baseUrl + apidefinitions.updateDecisionParameter;
    return this.http.post<GenericResponse>(url, request, this.getAuthorizedHeader())
  }
  getDecisionTable() {
    let url = environment.baseUrl + apidefinitions.getDecisionTable;
    return this.http.post<DecisionTable>(url, null, this.getAuthorizedHeader())
  }
  updateDecisionTimes(request: any) {
    let url = environment.baseUrl + apidefinitions.updateDecisionTimes;
    return this.http.post<UpdateDecisionTimes>(url, request, this.getAuthorizedHeader())
  }
  updateDecisionTable(request: any) {
    let url = environment.baseUrl + apidefinitions.updateDecisionTable;
    return this.http.post<UpdateDecisionTimes>(url, request, this.getAuthorizedHeader())
  }
  /**************Invitation API*******************/
  createInvitation(request: any) {
    let url = environment.baseUrl + apidefinitions.createInvitation;
    return this.http.post<CreateInvitation>(url, request, this.getAuthorizedHeader())
  }
  getAllInvitation(request: any) {
    let url = environment.baseUrl + apidefinitions.getInvitation;
    return this.http.post<InvitationData>(url, request, this.getAuthorizedHeader())
  }
  /*********Scan**********/
  getSwiftTransfers(payload: any) {
    let url = environment.baseUrl + apidefinitions.getSwiftTransfers;
    return this.http.post<SwiftTransfers>(url, payload, this.getAuthorizedHeader())
  }
  scanBeneficiary(payload: any) {
    let url = environment.baseUrl + apidefinitions.scanBeneficiary;
    return this.http.post<ScanBeneficiary>(url, payload, this.getAuthorizedHeader())
  }
  updateSwiftTransfer(payload: any) {
    let url = environment.baseUrl + apidefinitions.updateSwiftTransfer;
    return this.http.post<ScanBeneficiary>(url, payload, this.getAuthorizedHeader())
  }
  getIncomeSource() {
    let url = environment.baseUrl + apidefinitions.IncomeSource;
    return this.http.post<IncomeSourcesValue>(url, null)
  }

  getUserFormData(userId: string) {
    let url = `${environment.baseUrl}${apidefinitions.getCustomerDeatils}?UserID=${userId}`;
    return this.http.get<CustomerFormData>(url, this.getAuthorizedHeader())
  }

  getClientClasificationCustomersDetails(userId: string) {
    let url = `${environment.baseUrl}${apidefinitions.getClientClasificationCustomersDetails}?UserID=${userId}`;
    return this.http.get<ClientClassificationFormData>(url, this.getAuthorizedHeader())
  }

  postUserFormData(payload: any) {

    let url = environment.baseUrl + apidefinitions.saveCustomerDeatils;
    return this.http.post<any>(url, payload, this.getAuthorizedHeader());

  }

  updateCustomersDetails(payload: any) {
    return this.postUserFormData(payload)
  }
}
